import logoImg from "../../assets/imgs/logo.png";

export default {
  id: "webinarvault",
  appName: "WebinarVault",
  logo: logoImg,

  labels: {
    videos: "Webinars",
    myVideos: "My Webinars",
    search: "Search webinars...",
    content: "webinars",
    contentSingular: "webinar",
    blog: "Blog",
  },

  footer: { owner: "WebinarVault", email: null, stripped: false },

  theme: {
    accent: "#2563eb",
    headerTextCls: "text-blue-600 dark:text-blue-400",
    searchRingCls: "focus:ring-blue-500",
    quoteIconCls: "text-blue-600 dark:text-blue-400",
    quoteTextCls: "text-blue-400 dark:text-blue-300",
    quoteRingCls: "ring-blue-500",
    quoteBorderCls: "border-blue-500 dark:border-blue-400",
    navActiveCls: "bg-blue-50 text-blue-600 dark:bg-blue-900/40 dark:text-blue-400",
    navActiveDrawerCls: "bg-blue-50 text-blue-600 dark:bg-blue-900/40 dark:text-blue-400 border-r-2 border-blue-500",
    chat: {
      accent: "#2563eb",
      accentShadow: "rgba(37, 99, 235, 0.4)",
      tabActiveBg: "#dbeafe",
      tabActiveText: "#1d4ed8",
      tabActiveBorder: "rgba(37, 99, 235, 0.35)",
    },
  },

  features: {
    blog: true,
    payments: true,
    communityDrip: true,
    shareDrip: false,
    quotePortal: true,
    combatTools: false,
    sportsScorebug: false,
    telegramChat: true,
  },

  communityDripCuratorId: "687544e286815879896f21ed",

  seoDescription:
    "Turn webinars into chapters, Magic Quotes, and Auto-Condense highlight reels in minutes.",

  marketing: {
    features: [
      { emoji: "✦", title: "Auto-Condense Entire Video", desc: "One click turns a 60-minute webinar into a 3-minute condensed video. Every key moment, stitched together automatically. No editing required." },
      { emoji: "📑", title: "Auto-Chaptered Webinars", desc: "AI breaks webinars into logical chapters so you can skim content quickly and zero in on highlights." },
      { emoji: "💬", title: "Pull Quotes, Automatically", desc: "AI extracts the most quotable lines from every chapter. Copy them into decks, posts, emails, or follow-ups." },
      { emoji: "✂️", title: "One-Click Clips", desc: "Turn any pull quote into a shareable video clip. Or set your own cue points for precise control." },
      { emoji: "🔍", title: "Searchable Content", desc: "Search across all your webinars by keywords, topics, or quotes. Find any moment across your entire content library." },
      { emoji: "🧩", title: "Embeddable Widget", desc: "Create a custom video portal for your chaptered webinars that works on any website or landing page." },
      { emoji: "❝", title: "Top Pull Quotes Portal", desc: "A second embeddable portal that surfaces the best pull quotes from your entire library — auto-aggregated or hand-picked." },
      { emoji: "📸", title: "Better Screenshots", desc: "The best way to capture screengrabs. Key for those webinars heavy on presentation text and documentation." },
    ],
    personas: [
      { title: "The Busy Executive", tag: "Plow through boring webinars in minutes.", desc: "Easily find a few nuggets of insight from any recording without sitting through the whole thing." },
      { title: "The Demand Gen Lead", tag: "Turn one event into 30 days of social growth.", desc: "Extract clips, quotes, and threads from every webinar — fuel your pipeline without lifting a finger." },
      { title: "The Product Marketer", tag: "Get the key quotes from any competitor webinar.", desc: "Upload recordings of competitors' webinars to easily get the key intelligence you need in seconds." },
      { title: "The Content Strategist", tag: "Repurpose one recording into a month of content.", desc: "Blog posts, social cards, newsletter quotes — all sourced from a single webinar upload." },
    ],
    hero: {
      title: "Auto-Condense Any Webinar. Instantly.",
      sub: "Upload a recording. AI pulls the best quotes, creates clips, and auto-condenses the entire video into a shareable summary -- automatically.",
    },
    loginVisitor: {
      title: "Get More From Every Webinar",
      desc: "Upload a recording. Get pull quotes, clips, chapters, and auto-condensed video -- automatically.",
    },
    sections: {
      featuresTitle: "More Insights, Less Time",
      featuresSub: "Upload any webinar and unlock organized chapters with pull quotes ready to copy, clip, or auto-condense.",
      demoTitle: "See WebinarVault in Action",
      personasTitle: "Works Across Many Use Cases",
      personasSub: "WebinarVault works for anyone buried in replay links.",
      finalCtaTitle: "Ready to auto-condense your next webinar?",
      finalCtaSub: "Three days and 50,000 tokens for free. Start in under a minute.",
    },
    blogLabel: "Blog",
  },
};
